 $(document).on("click", ".add-to-cart", function() {
       var variantid = $(this).data('id');
         // alert(variantid);
           $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: variantid
              },
              dataType: 'json',
              success: function(cart) {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
              }
            });
  });